<template>
  <div>
    <p>welcome to the main page {{this.uid}}</p>

    <p>hello {{this.user.username}}</p>
    <p>Welcome back {{this.user.firstName}}</p>
  </div>
</template>
<script>
/* eslint-disable */
import db from "../database";
// import firebase from "firebase";
export default {
  name: "MainPage",
  props: ["uid"],

  data() {
    return {
      user: ""
    };
  },
  firestore() {
    return {
      user: db.collection("Users").doc(this.uid)
    };
  },
  mounted() {

  },
  methods: {
    test() {

      console.log("Current uid: " + this.uid);
      let test = this.user;
      console.log();
      if (test == null) {
        console.log("no such user with id " + this.uid);
      }

      console.log("Hello" + this.user.username);
    },

  }
};
</script>
